import { Box, Flex } from '@chakra-ui/react';
import { Spinner } from 'components/elements/Spinner';
import ChatView from 'components/widgets/Chat/ChatView';
import EmptyState from 'components/widgets/ScoutAgent/MainView/EmptyState';
import { Session } from 'services/API/AIInteractionAPI';

const mainViewStyle = {
  flex: 1,
  height: '100%',
  minWidth: 0,
  backgroundColor: 'white',
};

const spinnerContainerStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
};

type MainViewProps = {
  onPromptSubmit: (arg0: string) => void;
  selectedChatId?: string | null;
  selectedChat?: Session | null;
  isLoadingSelectedChat?: boolean;
  isAwaitingResponse?: boolean;
};

const MainView = ({
  onPromptSubmit,
  selectedChatId,
  selectedChat,
  isLoadingSelectedChat,
  isAwaitingResponse,
}: MainViewProps) => {
  if (selectedChatId == null) {
    return (
      <Box as="main" sx={mainViewStyle}>
        <EmptyState onPromptSubmit={onPromptSubmit} />
      </Box>
    );
  }

  if (isLoadingSelectedChat) {
    return (
      <Flex as="main" sx={{ ...mainViewStyle, ...spinnerContainerStyle }}>
        <Spinner />
      </Flex>
    );
  }

  if (selectedChat) {
    return (
      <Box as="main" sx={mainViewStyle} key={selectedChatId}>
        <ChatView chat={selectedChat} isAwaitingResponse={isAwaitingResponse} />
      </Box>
    );
  }

  return (
    <Flex as="main" sx={{ ...mainViewStyle, ...spinnerContainerStyle }}>
      <Spinner />
    </Flex>
  );
};

export default MainView;
